import { derailRecords } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

export default function DerailRecords() {
  return (
    <section id="derail" className="w-full bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Derailment Records"
          title="翻车记录榜"
          desc="按综合热度、商业影响与讨论量折算「翻车指数」，记录这一周里公众人物形象的明显滑坡。"
          action={
            <span className="inline-flex items-center gap-2 text-[12px] text-foreground-600 w-fit">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
              指数每日 12:00 更新
            </span>
          }
        />

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-background-200/70 text-[12px] font-semibold text-foreground-600">
            <span className="col-span-1">排名</span>
            <span className="col-span-3">人物 / 身份</span>
            <span className="col-span-3">近期事件</span>
            <span className="col-span-3">翻车指数</span>
            <span className="col-span-2 text-right">状态</span>
          </div>

          {derailRecords.map((rec) => (
            <div
              key={rec.rank}
              className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4 items-center px-5 md:px-6 py-4 border-t border-background-200 hover:bg-background-100 transition-colors"
            >
              <div className="md:col-span-1 flex items-center gap-3">
                <span
                  className={`flex items-center justify-center w-7 h-7 rounded-md text-[13px] font-bold ${
                    rec.rank <= 3
                      ? 'bg-primary-600 text-background-50'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {rec.rank}
                </span>
              </div>

              <div className="md:col-span-3 flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-secondary-100 text-secondary-900 font-heading font-bold text-[15px]">
                  {rec.name.slice(0, 1)}
                </span>
                <div>
                  <div className="text-[14px] font-semibold text-foreground-950">{rec.name}</div>
                  <div className="text-[12px] text-foreground-500">{rec.role}</div>
                </div>
              </div>

              <div className="md:col-span-3">
                <a
                  href="#latest"
                  className="text-[13px] text-foreground-700 hover:text-primary-700 transition-colors"
                >
                  {rec.event}
                </a>
                <div className="text-[11px] text-foreground-400 mt-0.5">{rec.date}</div>
              </div>

              <div className="md:col-span-3">
                <div className="flex items-center gap-3">
                  <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                    <div
                      className={`h-full rounded-full ${
                        rec.index >= 80 ? 'bg-primary-600' : 'bg-accent-500'
                      }`}
                      style={{ width: `${rec.index}%` }}
                    />
                  </div>
                  <span className="text-[13px] font-semibold text-foreground-800 tabular-nums w-8 text-right">
                    {rec.index}
                  </span>
                </div>
              </div>

              <div className="md:col-span-2 flex md:justify-end">
                <span className="inline-flex items-center gap-1.5 text-[12px] font-medium bg-accent-100 text-accent-900 px-2.5 py-1 rounded-full">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-error-warning-line text-[12px]" />
                  </span>
                  {rec.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}